/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import InboxPage from './InboxPage'
import {GetAllData, GetRmsChatList} from './InboxSlice/InboxSlice'
import {GetAllData as customNumberList} from '../accounts/CustomNumber/CustomNumberSlice/CustomNumberSlice'
import {GetAllData as businessList} from '../accounts/BusinessName/BusinessNameSlice/BusinessSlice'
import {getDedicatedNumberList} from '../accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'

const InboxWrapper: FC = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(GetRmsChatList())
    dispatch(getDedicatedNumberList({page: 1, size: 10}))
    dispatch(customNumberList())
    dispatch(businessList())
    // dispatch(GetAllData({page: 1, sortField: 'createdAt', sortOrder: 'descend', limit: 10}))
  }, [])
  return (
    <>
      <InboxPage />
    </>
  )
}

export {InboxWrapper}
